import { render, staticRenderFns } from "./ReceiptReportCard.vue?vue&type=template&id=2870927c"
import script from "./ReceiptReportCard.vue?vue&type=script&lang=js"
export * from "./ReceiptReportCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports